import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@utils/consts';
import { queryFetch } from '@services/api';
import { ApiError } from '@root/globalTypes';
import { useQueryParams } from '@hooks/queryParams';
import { EquipmentSchedulesConflictsProps, EquipmentSchedulesConflictsRespSuccess } from './types';

export const useGetEquipmentSchedulesConflicts = ({
  startsAt,
  endsAt,
  date,
  scheduleId,
  taskType,
  enabled = true,
}: EquipmentSchedulesConflictsProps) => {
  const { parseParams } = useQueryParams();

  const queryParams = parseParams({ startsAt, endsAt, date, scheduleId, taskType });

  const { data, error, isLoading } = useQuery<EquipmentSchedulesConflictsRespSuccess, ApiError>({
    queryKey: [...queryKeys.schedules.equipmentConflicts, queryParams],
    queryFn: () => queryFetch({ url: `equipment_schedules_conflicts${queryParams}` }),
    placeholderData: (previousData) => previousData as EquipmentSchedulesConflictsRespSuccess,
    enabled: Boolean((startsAt && endsAt) || date) && enabled,
  });

  return {
    data,
    error,
    isLoading: isLoading && Boolean((startsAt && endsAt) || date) && enabled,
  };
};
